export const banks = [
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "340",
    branch_name: "Karen Waterfront Platinum",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "341",
    branch_name: "KCB Ngong Branch",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "325",
    branch_name: "Garden City",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "326",
    branch_name: "JKIA",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "327",
    branch_name: "Makutano",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "330",
    branch_name: "KCB NextGen",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "331",
    branch_name: "KCB Mogotio",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "329",
    branch_name: "Two Rivers",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "332",
    branch_name: "KCB Upperhill Platinum",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "337",
    branch_name: "KCB Kilimani Platinum",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "339",
    branch_name: "KCB Utawala",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "302",
    branch_name: "Diaspora",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "303",
    branch_name: "Kisii West",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "304",
    branch_name: "Mbita",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "305",
    branch_name: "Sori",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "306",
    branch_name: "Hurlingham",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "307",
    branch_name: "Kibera",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "308",
    branch_name: "Thika Road Mall Branch",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "309",
    branch_name: "Kasarani Branch",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "310",
    branch_name: "KCB Maasai Mara",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "311",
    branch_name: "KCB Kabartonjo",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "312",
    branch_name: "KCB Eldoret East",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "313",
    branch_name: "Kikim",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "314",
    branch_name: "KCB JKUAT",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "315",
    branch_name: "KCB Changamwe",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "316",
    branch_name: "KCB Makongeni",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "317",
    branch_name: "KCB Syokimau",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "318",
    branch_name: "KCB Moi Referral Hospital",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "319",
    branch_name: "KCB Kitale Advantage",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "320",
    branch_name: "KCB Lavington",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "322",
    branch_name: "KCB Riverside Advantage",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "323",
    branch_name: "KCB Gigiri Square",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "324",
    branch_name: "Kayole",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "214",
    branch_name: "Gatundu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "215",
    branch_name: "Emali",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "216",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "217",
    branch_name: "KCB Flamingo",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "218",
    branch_name: "Njoro",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "219",
    branch_name: "Mutomo",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "220",
    branch_name: "Mariakani",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "221",
    branch_name: "Mpeketoni",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "222",
    branch_name: "Mtitu Andei",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "223",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "224",
    branch_name: "Taveta",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "225",
    branch_name: "Kengeleni",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "226",
    branch_name: "Garsen",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "227",
    branch_name: "Watamu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "228",
    branch_name: "Bondo",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "229",
    branch_name: "Busia",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "230",
    branch_name: "Homa Bay",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "231",
    branch_name: "Kapsowar",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "232",
    branch_name: "Kehancha",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "233",
    branch_name: "Keroka",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "234",
    branch_name: "Kilgoris",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "235",
    branch_name: "Kimilili",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "236",
    branch_name: "Litein",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "237",
    branch_name: "Londiani Branch",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "238",
    branch_name: "Luanda",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "239",
    branch_name: "Malaba",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "240",
    branch_name: "Muhoroni",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "241",
    branch_name: "Oyugis",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "242",
    branch_name: "Ugunja",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "243",
    branch_name: "United Mall",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "244",
    branch_name: "Serem",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "245",
    branch_name: "Sondu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "246",
    branch_name: "Kisumu West",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "247",
    branch_name: "Marigat",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "248",
    branch_name: "Mois Bridge",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "249",
    branch_name: "Mashariki",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "250",
    branch_name: "Naro Moro",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "251",
    branch_name: "Kiriaini",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "252",
    branch_name: "Egerton University",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "253",
    branch_name: "Maua",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "254",
    branch_name: "Kawangare",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "255",
    branch_name: "Kimathi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "256",
    branch_name: "Namanga",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "288",
    branch_name: "Haile Selassie",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "289",
    branch_name: "Salama House Mortgage Centre",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "290",
    branch_name: "Garden Plaza",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "291",
    branch_name: "Sarit Centre Mortgage Centre",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "292",
    branch_name: "Cpc Bulk Corporate Cheques",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "293",
    branch_name: "Trade Services",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "295",
    branch_name: "Nairobi High Court",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "296",
    branch_name: "Mombasa High Court",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "297",
    branch_name: "Kisumu Airport",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "298",
    branch_name: "Port Victoria",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "300",
    branch_name: "Nyali",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "301",
    branch_name: "Westgate Advantage",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "287",
    branch_name: "Kisauni",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "257",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "258",
    branch_name: "Kwale",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "259",
    branch_name: "Prestige Plaza",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "260",
    branch_name: "Kariobangi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "263",
    branch_name: "Biashara Street",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "266",
    branch_name: "Ngara",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "267",
    branch_name: "Kyuso",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "270",
    branch_name: "Masii",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "271",
    branch_name: "Menengai Crater",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "272",
    branch_name: "Town Centre",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "278",
    branch_name: "Makindu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "283",
    branch_name: "Rongo",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "284",
    branch_name: "Isibania",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "285",
    branch_name: "Kiserian",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "286",
    branch_name: "Mwembe Tayari",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "342",
    branch_name: "Imara Daima",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "343",
    branch_name: "Takaba Town",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "163",
    branch_name: "Eldama Ravine",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "164",
    branch_name: "Kibwezi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "166",
    branch_name: "Kapsabet",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "167",
    branch_name: "University Way",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "168",
    branch_name: "KCB Eldoret West",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "169",
    branch_name: "Garissa",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "124",
    branch_name: "Mumias",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "125",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "127",
    branch_name: "Moyale",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "129",
    branch_name: "Kikuyu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "130",
    branch_name: "Tala",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "131",
    branch_name: "Kajiado",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "133",
    branch_name: "KCB Custody services",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "134",
    branch_name: "Matuu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "135",
    branch_name: "Kitui",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "136",
    branch_name: "Mvita",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "137",
    branch_name: "Jogoo Rd Nairobi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "139",
    branch_name: "Card Centre",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "140",
    branch_name: "Marsabit",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "141",
    branch_name: "Sarit Centre",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "142",
    branch_name: "Loitokitok",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "143",
    branch_name: "Nandi Hills",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "144",
    branch_name: "Lodwar",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "145",
    branch_name: "Un Gigiri",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "146",
    branch_name: "Hola",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "147",
    branch_name: "Ruiru",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "148",
    branch_name: "Mwingi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "149",
    branch_name: "Kitale",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "150",
    branch_name: "Mandera",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "151",
    branch_name: "Kapenguria",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "152",
    branch_name: "Kabarnet",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "153",
    branch_name: "Wajir",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "154",
    branch_name: "Maralal",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "155",
    branch_name: "Limuru",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "157",
    branch_name: "Ukunda",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "158",
    branch_name: "Iten",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "159",
    branch_name: "Gilgil",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "161",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "162",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "338",
    branch_name: "KCB Langata",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "344",
    branch_name: "KCB Rumuruti Branch",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "091",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "092",
    branch_name: "KCB CPC",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "094",
    branch_name: "Head Office",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "095",
    branch_name: "Wote",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "096",
    branch_name: "Head Office Finance",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "100",
    branch_name: "Moi Avenue Nairobi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "101",
    branch_name: "Kipande House",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "102",
    branch_name: "Treasury Sq Mombasa",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "103",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "104",
    branch_name: "Kicc",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "105",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "106",
    branch_name: "Kericho",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "107",
    branch_name: "Tom Mboya",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "108",
    branch_name: "Thika",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "109",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "110",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "111",
    branch_name: "Kilindini Mombasa",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "112",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "113",
    branch_name: "Industrial Area Nairobi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "114",
    branch_name: "River Road",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "115",
    branch_name: "Muranga",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "116",
    branch_name: "Embu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "117",
    branch_name: "Kangema",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "119",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "120",
    branch_name: "Karatina",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "121",
    branch_name: "Siaya",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "122",
    branch_name: "Nyahururu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "123",
    branch_name: "Meru",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "173",
    branch_name: "Lamu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "174",
    branch_name: "Kilifi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "175",
    branch_name: "Milimani",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "176",
    branch_name: "Nyamira",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "177",
    branch_name: "Mukuruweini",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "180",
    branch_name: "Village Market",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "181",
    branch_name: "Bomet",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "183",
    branch_name: "Mbale",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "184",
    branch_name: "Narok",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "185",
    branch_name: "Othaya",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "186",
    branch_name: "Voi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "188",
    branch_name: "Webuye",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "189",
    branch_name: "Sotik",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "190",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "191",
    branch_name: "Kisii",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "192",
    branch_name: "Migori",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "193",
    branch_name: "Githunguri",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "194",
    branch_name: "Machakos",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "195",
    branch_name: "Kerugoya",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "196",
    branch_name: "Chuka",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "197",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "198",
    branch_name: "Wundanyi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "199",
    branch_name: "Malindi",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "201",
    branch_name: "Capital Hill",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "202",
    branch_name: "Karen",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "203",
    branch_name: "Lokichogio",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "204",
    branch_name: "Gateway Msa Road",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "205",
    branch_name: "Buruburu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "206",
    branch_name: "Chogoria",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "207",
    branch_name: "Kangare",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "208",
    branch_name: "Kianyaga",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "209",
    branch_name: "Nkubu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "210",
    branch_name: "Ol Kalou",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "211",
    branch_name: "Makuyu",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "212",
    branch_name: "Mwea",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "213",
    branch_name: "Njambini",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "333",
    branch_name: "Kakuma Branch",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "334",
    branch_name: "KCB Parklands",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "335",
    branch_name: "KCB Diani",
  },
  {
    bank_name: "Kenya Commercial Bank Limited",
    bank_code: "01",
    branch_code: "336",
    branch_name: "KCB Eldoret Advantage Branch",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "000",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "001",
    branch_name: "Kericho",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "002",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "003",
    branch_name: "Kitale",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "004",
    branch_name: "Treasury Square",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "005",
    branch_name: "Kilindini",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "006",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "008",
    branch_name: "Moi Avenue",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "009",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "010",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "011",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "012",
    branch_name: "Thika",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "015",
    branch_name: "Westlands",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "016",
    branch_name: "Machakos",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "017",
    branch_name: "Meru",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "019",
    branch_name: "Harambee Avenue",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "053",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "054",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "064",
    branch_name: "Koinage",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "071",
    branch_name: "Yaya Centre Branch",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "072",
    branch_name: "Ruaraka",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "073",
    branch_name: "Langata",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "074",
    branch_name: "Makupa",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "075",
    branch_name: "Karen",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "076",
    branch_name: "Muthaiga",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "078",
    branch_name: "C.o.u",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "079",
    branch_name: "Ukay",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "080",
    branch_name: "Two Rivers Branch",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "081",
    branch_name: "Kisii",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "082",
    branch_name: "Upper Hill Branch",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "083",
    branch_name: "Nyali",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "084",
    branch_name: "Chiromo",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "085",
    branch_name: "Greenspan",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "086",
    branch_name: "The T-Mall",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "087",
    branch_name: "The Junction",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "089",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "090",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "091",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "Standard Chartered Bank Kenya Ltd",
    bank_code: "02",
    branch_code: "092",
    branch_name: "UN Gigiri",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "140",
    branch_name: "Two Rivers",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "007",
    branch_name: "Kericho Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "008",
    branch_name: "Kisii Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "009",
    branch_name: "Kisumu Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "010",
    branch_name: "South C Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "011",
    branch_name: "Limuru Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "012",
    branch_name: "Malindi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "013",
    branch_name: "Meru Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "014",
    branch_name: "Eastleigh Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "015",
    branch_name: "Kitui Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "016",
    branch_name: "Nkrumah Road Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "017",
    branch_name: "Garissa Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "018",
    branch_name: "Nyamira Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "019",
    branch_name: "Kilifi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "020",
    branch_name: "Office Park Westlands",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "026",
    branch_name: "Kakamega Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "001",
    branch_name: "Head Office - Vpc",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "002",
    branch_name: "Kapsabet Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "003",
    branch_name: "Eldoret Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "004",
    branch_name: "Embu Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "005",
    branch_name: "Murang A Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "006",
    branch_name: "Kapenguria Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "021",
    branch_name: "Barclaycard Operations",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "022",
    branch_name: "Paymants And International Services",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "023",
    branch_name: "Gilgil Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "024",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "049",
    branch_name: "Lavington Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "050",
    branch_name: "Tala",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "051",
    branch_name: "Homa Bay Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "052",
    branch_name: "Ongata Rongai Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "053",
    branch_name: "Othaya Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "054",
    branch_name: "Voi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "055",
    branch_name: "Muthaiga Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "056",
    branch_name: "Barclays Advisory And Reg. Services",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "057",
    branch_name: "Githunguri Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "058",
    branch_name: "Webuye Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "059",
    branch_name: "Kasarani Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "060",
    branch_name: "Chuka Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "061",
    branch_name: "Nakumatt-westgate Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "062",
    branch_name: "Kabarnet Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "063",
    branch_name: "Kerugoya Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "064",
    branch_name: "Taveta Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "065",
    branch_name: "Karen Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "066",
    branch_name: "Wundanyi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "067",
    branch_name: "Ruaraka Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "068",
    branch_name: "Kitengela Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "069",
    branch_name: "Wote Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "070",
    branch_name: "Enterprise Road Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "071",
    branch_name: "Nakumatt Meru Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "072",
    branch_name: "Juja Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "073",
    branch_name: "Westlands Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "074",
    branch_name: "Kikuyu Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "075",
    branch_name: "Moi Avenue-nairobi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "076",
    branch_name: "Nyali",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "077",
    branch_name: "Absa Towers Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "034",
    branch_name: "Kawangware",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "035",
    branch_name: "Mbale",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "036",
    branch_name: "Plaza Premier Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "037",
    branch_name: "River Road Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "038",
    branch_name: "Chomba House-river Road",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "039",
    branch_name: "Mumias Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "040",
    branch_name: "Machakos Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "041",
    branch_name: "Narok Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "042",
    branch_name: "Isiolo Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "043",
    branch_name: "Ngong Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "044",
    branch_name: "Maua Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "045",
    branch_name: "Hurlingham Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "046",
    branch_name: "Makupa Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "047",
    branch_name: "Development House Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "048",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "027",
    branch_name: "Nakuru East",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "028",
    branch_name: "Buruburu",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "029",
    branch_name: "Bomet",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "030",
    branch_name: "Nyeri Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "031",
    branch_name: "Thika Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "032",
    branch_name: "Port Mombasa",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "033",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "128",
    branch_name: "Bamburi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "130",
    branch_name: "Harambee Ave - Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "132",
    branch_name: "Kitale Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "139",
    branch_name: "Nyahururu Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "144",
    branch_name: "Treasury Operations",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "145",
    branch_name: "Moi Avenue Mombasa -  Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "151",
    branch_name: "Cash Monitoring Unit",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "190",
    branch_name: "Nanyuki Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "206",
    branch_name: "Karatina Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "220",
    branch_name: "Mombasa Nyerere Ave -  Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "273",
    branch_name: "Consumer Operations",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "300",
    branch_name: "Finance Department",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "337",
    branch_name: "Documents And Securities  Dsc",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "340",
    branch_name: "Retail Credit Team",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "354",
    branch_name: "Credit Operations",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "400",
    branch_name: "Head office",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "078",
    branch_name: "Kiriaini Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "079",
    branch_name: "Butere Road Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "080",
    branch_name: "Migori Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "081",
    branch_name: "Digo Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "082",
    branch_name: "Haile Selassie Avenue Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "083",
    branch_name: "Nairobi University Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "084",
    branch_name: "Bunyala Road",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "086",
    branch_name: "Nairobi West Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "087",
    branch_name: "Parklands",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "088",
    branch_name: "Busia",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "089",
    branch_name: "Pangani Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "090",
    branch_name: "Abc Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "093",
    branch_name: "Kariobangi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "094",
    branch_name: "Queensway House Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "095",
    branch_name: "Nakumatt Embakasi Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "096",
    branch_name: "Barclays Merchant Finance Ltd.",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "097",
    branch_name: "Barclays Securities Services (k",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "100",
    branch_name: "Diani Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "103",
    branch_name: "Nairobi J.k.i.a Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "105",
    branch_name: "Village Market - Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "106",
    branch_name: "Sarit Centre - Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "109",
    branch_name: "Yaya Centre- Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "111",
    branch_name: "Naivasha Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "113",
    branch_name: "Market Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "114",
    branch_name: "Changamwe Branch",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "117",
    branch_name: "Rahimtulla Trust Towers - Premier Life Centre",
  },
  {
    bank_name: "Absa Bank Kenya Plc",
    bank_code: "03",
    branch_code: "125",
    branch_name: "Nakuru West Branch",
  },
  {
    bank_name: "Bank of India",
    bank_code: "05",
    branch_code: "000",
    branch_name: "Kenyatta Avenue , Nairobi",
  },
  {
    bank_name: "Bank of India",
    bank_code: "05",
    branch_code: "001",
    branch_name: "Nkrumah Road , Mombasa",
  },
  {
    bank_name: "Bank of India",
    bank_code: "05",
    branch_code: "002",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Bank of India",
    bank_code: "05",
    branch_code: "003",
    branch_name: "Westlands",
  },
  {
    bank_name: "Bank of India",
    bank_code: "05",
    branch_code: "005",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "017",
    branch_name: "Muthithi road",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "000",
    branch_name: "Nairobi Main",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "002",
    branch_name: "Digo Road, Mombasa",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "004",
    branch_name: "Thika",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "005",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "006",
    branch_name: "Sarit Centre",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "007",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "008",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "009",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "010",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "011",
    branch_name: "Nyali Mombasa",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "012",
    branch_name: "Meru",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "015",
    branch_name: "Diamond Plaza",
  },
  {
    bank_name: "Bank of Baroda(Kenya Ltd)",
    bank_code: "06",
    branch_code: "016",
    branch_name: "Mombasa Road",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "209",
    branch_name: "Mwembe Tayari",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "208",
    branch_name: "Ruiru Eastern Bypass",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "206",
    branch_name: "Nyeri",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "207",
    branch_name: "Karatina",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "210",
    branch_name: "Kakamega",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "033",
    branch_name: "River Road",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "034",
    branch_name: "Karen Hub",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "211",
    branch_name: "Kericho",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "213",
    branch_name: "Bungoma",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "212",
    branch_name: "Embu",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "216",
    branch_name: "Gikomba",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "214",
    branch_name: "Ngong",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "215",
    branch_name: "Kiambu",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "217",
    branch_name: "Naivasha",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "035",
    branch_name: "Garden City",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "036",
    branch_name: "Two Rivers Mall",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "101",
    branch_name: "City Centre",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "102",
    branch_name: "NIC House",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "103",
    branch_name: "Harbour House",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "105",
    branch_name: "Westlands",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "106",
    branch_name: "The Junction Br.",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "107",
    branch_name: "Nakuru",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "110",
    branch_name: "Harambee",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "111",
    branch_name: "Prestige-Ngong Road",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "112",
    branch_name: "Kisumu",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "113",
    branch_name: "Thika",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "114",
    branch_name: "Meru",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "118",
    branch_name: "Sameer Park",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "119",
    branch_name: "Karen",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "121",
    branch_name: "Taj Mall",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "122",
    branch_name: "ABC",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "123",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "124",
    branch_name: "Changamwe Branch",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "125",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "126",
    branch_name: "Riverside",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "127",
    branch_name: "Machakos",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "128",
    branch_name: "Lunga Lunga Square",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "129",
    branch_name: "Kilimani",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "130",
    branch_name: "Kitengela",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "146",
    branch_name: "Kilifi",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "147",
    branch_name: "Watamu",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "148",
    branch_name: "Diani",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "149",
    branch_name: "Kitale",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "200",
    branch_name: "Narok Branch",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "201",
    branch_name: "Lavington Branch",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "500",
    branch_name: "Head Office",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "501",
    branch_name: "Head Office",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "502",
    branch_name: "Head Office",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "503",
    branch_name: "Head Office",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "600",
    branch_name: "Head Office",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "131",
    branch_name: "Kisii",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "132",
    branch_name: "KMA Centre",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "133",
    branch_name: "Buru Buru",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "134",
    branch_name: "CPA Centre, Ruaraka",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "135",
    branch_name: "Rongai",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "141",
    branch_name: "Rosslyn Riviera",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "142",
    branch_name: "Ciata Mall",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "143",
    branch_name: "Parklands",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "144",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "145",
    branch_name: "Malindi",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "005",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "006",
    branch_name: "Mamlaka",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "007",
    branch_name: "Village Market",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "008",
    branch_name: "Cargo Centre",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "009",
    branch_name: "Park Side",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "026",
    branch_name: "Eldoret",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "027",
    branch_name: "Kisumu",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "028",
    branch_name: "Thika",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "029",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "030",
    branch_name: "Yaya Centre",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "031",
    branch_name: "Lavington",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "032",
    branch_name: "Machakos",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "016",
    branch_name: "Galleria Mall",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "017",
    branch_name: "Junction",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "018",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "019",
    branch_name: "Greenspan Mall",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "020",
    branch_name: "Moi Avenue Mombasa",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "021",
    branch_name: "Meru",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "022",
    branch_name: "Nakuru",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "023",
    branch_name: "Nyali",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "024",
    branch_name: "Diani",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "025",
    branch_name: "Changamwe",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "219",
    branch_name: "Busia",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "223",
    branch_name: "Kenol Town",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "222",
    branch_name: "Utawala Nairobi",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "221",
    branch_name: "Eastleigh Nairobi",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "218",
    branch_name: "Muranga",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "224",
    branch_name: "Kahawa Sukari",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "220",
    branch_name: "Chwele",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "226",
    branch_name: "Migori Branch",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "225",
    branch_name: "Wote Branch",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "115",
    branch_name: "Galleria (Bomas)",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "116",
    branch_name: "Eldoret",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "117",
    branch_name: "Village Market",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "001",
    branch_name: "Upper Hill",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "002",
    branch_name: "Wabera Street",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "003",
    branch_name: "Mama Ngina",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "004",
    branch_name: "Westlands Branch",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "104",
    branch_name: "Head Office-Fargo",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "108",
    branch_name: "Nyali",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "109",
    branch_name: "Nkrumah Road",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "204",
    branch_name: "Sarit Centre Branch",
  },
  {
    bank_name: "Central Bank Of Kenya",
    bank_code: "09",
    branch_code: "008",
    branch_name: "Kisii Centre",
  },
  {
    bank_name: "Central Bank Of Kenya",
    bank_code: "09",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Central Bank Of Kenya",
    bank_code: "09",
    branch_code: "001",
    branch_name: "Head Office",
  },
  {
    bank_name: "Central Bank Of Kenya",
    bank_code: "09",
    branch_code: "002",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Central Bank Of Kenya",
    bank_code: "09",
    branch_code: "003",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Central Bank Of Kenya",
    bank_code: "09",
    branch_code: "004",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Central Bank Of Kenya",
    bank_code: "09",
    branch_code: "006",
    branch_name: "Nakuru Centre",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "021",
    branch_name: "Two Rivers",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "023",
    branch_name: "Meru",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "024",
    branch_name: "Lavington Branch",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "022",
    branch_name: "UAP Towers",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "000",
    branch_name: "H/o Riverside",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "001",
    branch_name: "Kenindia",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "002",
    branch_name: "Biashara",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "003",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "004",
    branch_name: "Westlands",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "005",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "006",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "007",
    branch_name: "Parklands",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "008",
    branch_name: "Riverside Drive",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "009",
    branch_name: "Card Centre",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "010",
    branch_name: "Hurlingham",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "011",
    branch_name: "Capital Centre",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "012",
    branch_name: "Nyali",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "014",
    branch_name: "Kamukunji",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "015",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "016",
    branch_name: "Karen",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "017",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "020",
    branch_name: "Garden City",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "019",
    branch_name: "Thika",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "027",
    branch_name: "Baba Dogo",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "025",
    branch_name: "Village Market",
  },
  {
    bank_name: "Prime Bank Limited",
    bank_code: "10",
    branch_code: "026",
    branch_name: "Kitale",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "170",
    branch_name: "Kamulu Branch",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "156",
    branch_name: "Ridgeways Mall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "157",
    branch_name: "Two Rivers Mall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "158",
    branch_name: "JKIA",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "154",
    branch_name: "Gikomba Area 42",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "166",
    branch_name: "Kapenguria Sub - Branch",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "162",
    branch_name: "Litein",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "161",
    branch_name: "Kilimani",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "159",
    branch_name: "Emali",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "163",
    branch_name: "Thika Makongeni",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "160",
    branch_name: "Kangema",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "155",
    branch_name: "Utawala",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "020",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "021",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "022",
    branch_name: "Homa Bay",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "023",
    branch_name: "Embu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "024",
    branch_name: "Kericho",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "025",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "026",
    branch_name: "Muranga",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "027",
    branch_name: "Kayole",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "028",
    branch_name: "Karatina",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "029",
    branch_name: "Ukunda",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "030",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "031",
    branch_name: "University Way",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "032",
    branch_name: "Buru Buru",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "033",
    branch_name: "Athi River",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "034",
    branch_name: "Mumias",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "038",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "039",
    branch_name: "Thika",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "040",
    branch_name: "Nacico",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "041",
    branch_name: "Kariobangi",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "042",
    branch_name: "Kawangware",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "043",
    branch_name: "Makutano",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "044",
    branch_name: "Parliament road",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "045",
    branch_name: "Kimathi Street",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "046",
    branch_name: "Kitale",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "047",
    branch_name: "Githurai",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "048",
    branch_name: "Maua",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "049",
    branch_name: "City  Hall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "050",
    branch_name: "Digo Rd",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "051",
    branch_name: "Nbc",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "001",
    branch_name: "Finance And Accounts",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "002",
    branch_name: "Co-op House",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "003",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "004",
    branch_name: "Nkurumah Road",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "005",
    branch_name: "Meru",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "006",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "007",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "008",
    branch_name: "Kisii",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "009",
    branch_name: "Machakos",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "010",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "011",
    branch_name: "Ukulima",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "012",
    branch_name: "Kerugoya",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "013",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "014",
    branch_name: "Moi Avenue",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "015",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "017",
    branch_name: "Nyahururu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "018",
    branch_name: "Chuka",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "019",
    branch_name: "Wakulima Market",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "062",
    branch_name: "Zimmerman",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "063",
    branch_name: "Kenyatta Avenue Nakuru",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "064",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "065",
    branch_name: "Aga Khan Walk",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "066",
    branch_name: "Narok",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "067",
    branch_name: "Kitui",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "068",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "069",
    branch_name: "Embakasi",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "070",
    branch_name: "Kibera",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "071",
    branch_name: "Siakago",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "072",
    branch_name: "Kapsabet",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "073",
    branch_name: "Mbita",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "074",
    branch_name: "Kangemi",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "075",
    branch_name: "Dandora",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "076",
    branch_name: "Kajiado",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "077",
    branch_name: "Tala",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "078",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "079",
    branch_name: "River Road",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "080",
    branch_name: "Nyamira",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "081",
    branch_name: "Garisa",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "082",
    branch_name: "Bomet",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "083",
    branch_name: "Keroka",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "084",
    branch_name: "Gilgil",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "085",
    branch_name: "Tom Mboya",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "086",
    branch_name: "Likoni",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "087",
    branch_name: "Donholm",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "088",
    branch_name: "Mwingi",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "089",
    branch_name: "Ruaka",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "090",
    branch_name: "Webuye",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "094",
    branch_name: "Sacco Clearing Unit",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "097",
    branch_name: "Clearing Centre",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "100",
    branch_name: "Ndhiwa",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "101",
    branch_name: "Oyugis",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "102",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "103",
    branch_name: "Uganda Road Eldoret",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "104",
    branch_name: "Changamwe",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "105",
    branch_name: "Kondele",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "106",
    branch_name: "Githurai Kimbo",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "107",
    branch_name: "Mlolongo",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "108",
    branch_name: "Kilifi",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "109",
    branch_name: "Ol Kalau",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "110",
    branch_name: "Mbale",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "111",
    branch_name: "Kimilili",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "035",
    branch_name: "Stima Plaza",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "036",
    branch_name: "Westlands",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "037",
    branch_name: "Upper Hill",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "137",
    branch_name: "Gatundu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "138",
    branch_name: "Ruiru",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "139",
    branch_name: "Nyali Mall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "140",
    branch_name: "Yala",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "141",
    branch_name: "Maasai Mall - Ongata Rongai",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "142",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "143",
    branch_name: "Kiserian",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "144",
    branch_name: "Nandi Hills",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "145",
    branch_name: "Lodwar",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "147",
    branch_name: "Engineer",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "148",
    branch_name: "Rongo",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "149",
    branch_name: "Lavington Mall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "150",
    branch_name: "Bondo",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "151",
    branch_name: "Gigiri Mall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "152",
    branch_name: "United Mall, Kisumu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "153",
    branch_name: "Green House Mall",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "228",
    branch_name: "Shares Operations",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "247",
    branch_name: "Back Office Operations",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "250",
    branch_name: "E- Channels Unit",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "254",
    branch_name: "Diaspora Banking",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "266",
    branch_name: "Kilindini Port",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "270",
    branch_name: "Money Transfers Agency",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "052",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "053",
    branch_name: "Migori",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "054",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "055",
    branch_name: "Nkubu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "056",
    branch_name: "Enterprise Road",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "057",
    branch_name: "Busia",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "058",
    branch_name: "Siaya",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "059",
    branch_name: "Voi",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "060",
    branch_name: "Mariakani",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "061",
    branch_name: "Malindi",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "128",
    branch_name: "Marsabit",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "130",
    branch_name: "Dagoretti",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "131",
    branch_name: "Othaya",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "132",
    branch_name: "Limuru",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "133",
    branch_name: "Kikuyu",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "134",
    branch_name: "Githunguri",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "135",
    branch_name: "Karen",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "136",
    branch_name: "Mpeketoni",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "112",
    branch_name: "Kisii Highway",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "113",
    branch_name: "Kilgoris",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "114",
    branch_name: "Wote",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "116",
    branch_name: "Malaba",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "117",
    branch_name: "Molo",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "118",
    branch_name: "Mwea",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "119",
    branch_name: "Kutus",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "120",
    branch_name: "Umoja",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "121",
    branch_name: "Embakasi Junction",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "122",
    branch_name: "Kongowea",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "123",
    branch_name: "Langata Road",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "124",
    branch_name: "Juja",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "125",
    branch_name: "Ngong",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "126",
    branch_name: "Kawangware 46",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "127",
    branch_name: "Mombasa Road",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "092",
    branch_name: "Kabarnet Branch",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "091",
    branch_name: "Iten",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "115",
    branch_name: "Kasarani Branch",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "129",
    branch_name: "Kamakis",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "173",
    branch_name: "Chwele",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "093",
    branch_name: "Hindi Branch",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "174",
    branch_name: "THIKA KWAME NKRUMAH BRANCH",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "146",
    branch_name: "Kenol-Makuyu Branch",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "169",
    branch_name: "Eldoret - Kenyatta Street",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "171",
    branch_name: "Bamburi Branch",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "165",
    branch_name: "Chogoria",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "164",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "167",
    branch_name: "Maralal",
  },
  {
    bank_name: "Co-operative Bank of Kenya Limited",
    bank_code: "11",
    branch_code: "172",
    branch_name: "GREENWOOD MALL BRANCH",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "000",
    branch_name: "Central Business Unit",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "002",
    branch_name: "Kenyatta",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "003",
    branch_name: "Harambee",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "004",
    branch_name: "Hill",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "005",
    branch_name: "Busia",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "006",
    branch_name: "Kiambu",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "007",
    branch_name: "Meru",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "008",
    branch_name: "Karatina",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "009",
    branch_name: "Narok",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "010",
    branch_name: "Kisii",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "011",
    branch_name: "Malindi",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "012",
    branch_name: "Nyeri",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "013",
    branch_name: "Kitale",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "015",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "016",
    branch_name: "Limuru",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "017",
    branch_name: "Kitui",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "018",
    branch_name: "Molo",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "019",
    branch_name: "Bungoma",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "020",
    branch_name: "Nkrumah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "021",
    branch_name: "Kapsabet",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "022",
    branch_name: "Awendo",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "023",
    branch_name: "Portway-msa",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "082",
    branch_name: "Mwea Branch",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "025",
    branch_name: "Hospital Br.",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "026",
    branch_name: "Ruiru",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "027",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "028",
    branch_name: "Embu",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "029",
    branch_name: "Kakamega",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "030",
    branch_name: "Nakuru",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "031",
    branch_name: "Ukunda",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "032",
    branch_name: "Upper Hill",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "033",
    branch_name: "Nandi Hills",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "034",
    branch_name: "Migori",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "035",
    branch_name: "Westlands",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "036",
    branch_name: "Times Tower",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "037",
    branch_name: "Maua",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "038",
    branch_name: "WILSON AIRPORT",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "039",
    branch_name: "J.K.I.A.",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "040",
    branch_name: "Eldoret",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "056",
    branch_name: "Bomet",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "058",
    branch_name: "Greenspan",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "059",
    branch_name: "Sameer Park",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "060",
    branch_name: "SEKU",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "061",
    branch_name: "Ngong Road",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "062",
    branch_name: "Moi Avenue",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "063",
    branch_name: "Mountain Mall",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "065",
    branch_name: "Nyali Centre",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "066",
    branch_name: "Kilifi",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "067",
    branch_name: "South C Branch- KEBS",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "068",
    branch_name: "Kericho",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "070",
    branch_name: "Isiolo",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "071",
    branch_name: "South C - Red Cross",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "072",
    branch_name: "National Bank Premium Banking Kisumu",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "073",
    branch_name: "Yaya Centre",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "074",
    branch_name: "Gigiri",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "253",
    branch_name: "Narok Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "254",
    branch_name: "Ngong Rd Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "255",
    branch_name: "Nkuruma Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "256",
    branch_name: "Nyali Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "257",
    branch_name: "Nyeri Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "258",
    branch_name: "Ongata Rongai Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "259",
    branch_name: "Portway Hse Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "260",
    branch_name: "Ruiru Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "261",
    branch_name: "Sameer Park Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "262",
    branch_name: "SEKU Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "263",
    branch_name: "South C Red Cross Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "264",
    branch_name: "St. Pauls University Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "265",
    branch_name: "Technical Univ of MSA Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "266",
    branch_name: "Thika Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "093",
    branch_name: "Wajir",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "094",
    branch_name: "Bondeni",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "096",
    branch_name: "Mandera",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "098",
    branch_name: "Card Centre",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "099",
    branch_name: "Head Office",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "198",
    branch_name: "Central CLearing Centre",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "200",
    branch_name: "Head Office Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "201",
    branch_name: "Card Centre Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "202",
    branch_name: "Eastleigh Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "203",
    branch_name: "Kenyatta Ave Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "204",
    branch_name: "Wajir Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "205",
    branch_name: "Bondeni Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "206",
    branch_name: "Garissa Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "207",
    branch_name: "Mandera Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "208",
    branch_name: "Isiolo Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "209",
    branch_name: "Awendo Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "210",
    branch_name: "Bomet Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "211",
    branch_name: "Bungoma Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "212",
    branch_name: "Busia Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "213",
    branch_name: "Changamwe Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "214",
    branch_name: "Eldoret Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "215",
    branch_name: "Embu Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "216",
    branch_name: "Gigiri Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "217",
    branch_name: "Greenspan Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "218",
    branch_name: "Harambee Ave Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "219",
    branch_name: "Hill Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "220",
    branch_name: "Hospital Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "221",
    branch_name: "JKIA Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "222",
    branch_name: "Kakamega Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "223",
    branch_name: "Kapsabet Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "224",
    branch_name: "Karatina Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "225",
    branch_name: "Kenyatta Ave Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "226",
    branch_name: "Kenyatta University Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "227",
    branch_name: "Kericho Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "228",
    branch_name: "Kiambu Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "229",
    branch_name: "Kianjai Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "230",
    branch_name: "Kilifi Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "231",
    branch_name: "Kisii Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "232",
    branch_name: "Kisumu Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "267",
    branch_name: "Times Tower Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "268",
    branch_name: "TSC Upper Hill Building Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "269",
    branch_name: "Ukunda Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "270",
    branch_name: "Westlands Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "271",
    branch_name: "Wilson Airport NRI Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "272",
    branch_name: "Yaya Centre Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "233",
    branch_name: "Kisumu Premium Centre Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "234",
    branch_name: "Kitale Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "235",
    branch_name: "Kitengela Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "236",
    branch_name: "Kitui Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "237",
    branch_name: "Limuru Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "238",
    branch_name: "Lunga Lunga Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "239",
    branch_name: "Machakos Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "240",
    branch_name: "Malindi Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "241",
    branch_name: "Maua Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "242",
    branch_name: "Meru Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "243",
    branch_name: "Migori Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "244",
    branch_name: "Moi Ave Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "245",
    branch_name: "Moi University Eldoret Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "246",
    branch_name: "Mois Bridge Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "247",
    branch_name: "Molo Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "248",
    branch_name: "Mountain Mall Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "249",
    branch_name: "Mtwapa Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "250",
    branch_name: "Mutomo Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "251",
    branch_name: "Nakuru Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "252",
    branch_name: "Nandi Hills Amanah",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "041",
    branch_name: "MOIS BRIDGE",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "042",
    branch_name: "MUTOMO",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "043",
    branch_name: "KIANJAI",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "044",
    branch_name: "KENYATTA UNIVERSITY",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "045",
    branch_name: "ST PAULS UNIVERSITY",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "046",
    branch_name: "MOI UNIVERSITY ELDORET",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "047",
    branch_name: "MOI INT AIRPORT MOMBASA",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "048",
    branch_name: "Machakos",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "049",
    branch_name: "Kitengela",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "050",
    branch_name: "Kisumu",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "051",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "052",
    branch_name: "Changamwe",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "053",
    branch_name: "Garissa",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "054",
    branch_name: "Thika",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "055",
    branch_name: "Momasa Polytechnic University College",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "075",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "078",
    branch_name: "Wote",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "079",
    branch_name: "Lodwar",
  },
  {
    bank_name: "National Bank Of Kenya",
    bank_code: "12",
    branch_code: "081",
    branch_name: "Gikomba",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "011",
    branch_name: "Sameer Business Park",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "001",
    branch_name: "Koinange Street",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "004",
    branch_name: "Nakuru",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "005",
    branch_name: "Eldoret",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "006",
    branch_name: "Kitale",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "007",
    branch_name: "Westlands",
  },
  {
    bank_name: "M-Oriental Bank Limited",
    bank_code: "14",
    branch_code: "010",
    branch_name: "Mombasa",
  },
  {
    bank_name: "CITI BANK N A",
    bank_code: "16",
    branch_code: "000",
    branch_name: "Head Office , Nairobi",
  },
  {
    bank_name: "CITI BANK N A",
    bank_code: "16",
    branch_code: "400",
    branch_name: "Mombasa",
  },
  {
    bank_name: "CITI BANK N A",
    bank_code: "16",
    branch_code: "500",
    branch_name: "Gigiri Agency",
  },
  {
    bank_name: "CITI BANK N A",
    bank_code: "16",
    branch_code: "700",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Habib Bank AG Zurich",
    bank_code: "17",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Habib Bank AG Zurich",
    bank_code: "17",
    branch_code: "001",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Habib Bank AG Zurich",
    bank_code: "17",
    branch_code: "002",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Habib Bank AG Zurich",
    bank_code: "17",
    branch_code: "003",
    branch_name: "Westlands",
  },
  {
    bank_name: "Habib Bank AG Zurich",
    bank_code: "17",
    branch_code: "004",
    branch_name: "Nyali",
  },
  {
    bank_name: "Middle East Bank Kenya Limited",
    bank_code: "18",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Middle East Bank Kenya Limited",
    bank_code: "18",
    branch_code: "001",
    branch_name: "Nairobi",
  },
  {
    bank_name: "Middle East Bank Kenya Limited",
    bank_code: "18",
    branch_code: "002",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Middle East Bank Kenya Limited",
    bank_code: "18",
    branch_code: "003",
    branch_name: "Milimani",
  },
  {
    bank_name: "Middle East Bank Kenya Limited",
    bank_code: "18",
    branch_code: "004",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Middle East Bank Kenya Limited",
    bank_code: "18",
    branch_code: "005",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "043",
    branch_name: "Ukunda",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "000",
    branch_name: "Reinsurance Plaza Nairobi",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "001",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "002",
    branch_name: "Westlands",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "003",
    branch_name: "Uhuru Highway",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "004",
    branch_name: "River Road",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "005",
    branch_name: "Thika",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "006",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "007",
    branch_name: "Ruaraka",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "008",
    branch_name: "Monrovia Street",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "009",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "010",
    branch_name: "Ngong Road",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "011",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "012",
    branch_name: "Embakasi",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "014",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "015",
    branch_name: "Changamwe",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "016",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "017",
    branch_name: "KISII",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "018",
    branch_name: "MERU",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "019",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "020",
    branch_name: "Nyali",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "021",
    branch_name: "Galleria",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "022",
    branch_name: "Greenspan Mall",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "023",
    branch_name: "Upper Hilll",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "024",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "026",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "027",
    branch_name: "Sameer Business Park",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "028",
    branch_name: "Moi Avenue, Mombasa",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "029",
    branch_name: "Ongata Rongai II",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "030",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "031",
    branch_name: "Githurai",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "032",
    branch_name: "Embu",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "033",
    branch_name: "Gateway Mall",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "034",
    branch_name: "Kitale",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "035",
    branch_name: "South B",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "036",
    branch_name: "Digo Road",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "037",
    branch_name: "Outering Road",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "038",
    branch_name: "Likoni Road",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "039",
    branch_name: "Thika Road",
  },
  {
    bank_name: "Bank of  Africa Kenya Limited",
    bank_code: "19",
    branch_code: "040",
    branch_name: "Narok",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "000",
    branch_name: "Harambee Avenue",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "001",
    branch_name: "Muranga",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "002",
    branch_name: "Embu",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "003",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "004",
    branch_name: "Koinange Street",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "005",
    branch_name: "Thika",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "006",
    branch_name: "Meru",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "007",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "008",
    branch_name: "Laare",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "009",
    branch_name: "Maua",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "010",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "011",
    branch_name: "Head Office",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "012",
    branch_name: "Corporate",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "013",
    branch_name: "Umoja",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "014",
    branch_name: "River Road",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "015",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "016",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "017",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Consolidated Bank of Kenya Ltd",
    bank_code: "23",
    branch_code: "018",
    branch_name: "Taj Mall",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "016",
    branch_name: "Ngong Road Branch",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "017",
    branch_name: "Meru Branch",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "018",
    branch_name: "Nkuruma",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "500",
    branch_name: "Sumac Koinange",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "019",
    branch_name: "One Africa",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "001",
    branch_name: "Koinange Street",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "002",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "003",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "004",
    branch_name: "Kisii",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "005",
    branch_name: "Westlands",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "006",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "008",
    branch_name: "Nakuru, Kenyatta Avenue",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "009",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "010",
    branch_name: "Rongai",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "011",
    branch_name: "Mombasa- Nyali Centre",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "012",
    branch_name: "Thika",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "013",
    branch_name: "Lavington Mall",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "014",
    branch_name: "Machakos",
  },
  {
    bank_name: "Credit Bank PLC",
    bank_code: "25",
    branch_code: "015",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "020",
    branch_name: "Flax",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "021",
    branch_name: "Westlands",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "024",
    branch_name: "Marigat",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "022",
    branch_name: "Burnt Forest",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "025",
    branch_name: "Kapcherop",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "026",
    branch_name: "Kapenguria",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "027",
    branch_name: "Kaptumo",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "028",
    branch_name: "Eldama Ravine",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "001",
    branch_name: "Head Office",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "002",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "003",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "004",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "005",
    branch_name: "Mia",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "006",
    branch_name: "Jkia",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "007",
    branch_name: "Kirinyaga Rd Nakuru",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "008",
    branch_name: "Kabarak",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "009",
    branch_name: "Olenguruone",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "010",
    branch_name: "Kericho",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "011",
    branch_name: "Nandi Hills",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "012",
    branch_name: "Epz",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "013",
    branch_name: "Sheikh Karume",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "014",
    branch_name: "Kabarnet",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "015",
    branch_name: "Kitale",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "016",
    branch_name: "Narok",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "017",
    branch_name: "Bomet",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "018",
    branch_name: "Iten",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "019",
    branch_name: "Lessos",
  },
  {
    bank_name: "Access Bank Kenya PLC",
    bank_code: "26",
    branch_code: "023",
    branch_name: "Kiptagich",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "030",
    branch_name: "The Hub",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "031",
    branch_name: "Two Rivers",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "000",
    branch_name: "CFC Stanbic Head Office",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "002",
    branch_name: "Kenyatta Ave",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "021",
    branch_name: "Garden city",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "022",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "023",
    branch_name: "Karen",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "018",
    branch_name: "Meru",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "019",
    branch_name: "Buruburu",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "020",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "003",
    branch_name: "Digo road",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "004",
    branch_name: "Waiyaki Way",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "005",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "006",
    branch_name: "Harambee Avenue",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "007",
    branch_name: "Chiromo Road",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "008",
    branch_name: "International House",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "010",
    branch_name: "Upper Hill",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "011",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "012",
    branch_name: "Westgate",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "013",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "014",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "015",
    branch_name: "Thika",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "017",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "024",
    branch_name: "Kisii",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "025",
    branch_name: "Warwick",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "026",
    branch_name: "Private Clients",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "027",
    branch_name: "Nyali",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "028",
    branch_name: "Malindi",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "029",
    branch_name: "Changamwe",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "999",
    branch_name: "Central Processing H/o",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "032",
    branch_name: "Imaara Branch",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "033",
    branch_name: "Kericho Branch",
  },
  {
    bank_name: "Stanbic Bank Plc",
    bank_code: "31",
    branch_code: "034",
    branch_name: "Expressway Branch",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "011",
    branch_name: "Green House Mall(GHM)",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "010",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "000",
    branch_name: "Head Office/koinange St.",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "001",
    branch_name: "Westlands",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "002",
    branch_name: "Industrial Area Branch",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "003",
    branch_name: "Nkrumah Road Branch/mombasa",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "004",
    branch_name: "Kisumu Branch",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "005",
    branch_name: "Eldoret Branch",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "006",
    branch_name: "Meru Branch",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "007",
    branch_name: "Libra House",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "008",
    branch_name: "Nakuru",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "101",
    branch_name: "Central Operations 1",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "102",
    branch_name: "Central Operations 2",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "103",
    branch_name: "Central Operations 3",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "104",
    branch_name: "Central Operations 4",
  },
  {
    bank_name: "African Banking Corporation Limited",
    bank_code: "35",
    branch_code: "105",
    branch_name: "Central Operations 5",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "030",
    branch_name: "Fortis Office Park",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "000",
    branch_name: "Fedha Branch , Head Office",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "001",
    branch_name: "Moi Avenue Nairobi",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "002",
    branch_name: "Akiba Hse Mombasa",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "003",
    branch_name: "Plaza 2000",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "004",
    branch_name: "Westminister",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "005",
    branch_name: "Chambers",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "006",
    branch_name: "Thika",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "018",
    branch_name: "Busia",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "019",
    branch_name: "Malindi",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "020",
    branch_name: "Meru",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "021",
    branch_name: "Gikomba",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "022",
    branch_name: "UpperHill",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "023",
    branch_name: "Valley Arcade",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "024",
    branch_name: "Karen",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "025",
    branch_name: "Nyali Mombasa",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "026",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "027",
    branch_name: "Embakasi",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "028",
    branch_name: "Kitengela",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "029",
    branch_name: "Thika Mall",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "100",
    branch_name: "Head Office",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "007",
    branch_name: "Eldoret",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "008",
    branch_name: "Kisumu",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "009",
    branch_name: "Kisii",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "010",
    branch_name: "Kitale",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "011",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "012",
    branch_name: "Karatina",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "013",
    branch_name: "Westlands",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "014",
    branch_name: "United Mall",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "015",
    branch_name: "Nakuru",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "016",
    branch_name: "Jomo Kenyatta Avenue",
  },
  {
    bank_name: "ECO Bank Kenya LTD",
    bank_code: "43",
    branch_code: "017",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "017",
    branch_name: "Machakos",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "000",
    branch_name: "Nairobi",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "001",
    branch_name: "Nyerere",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "002",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "004",
    branch_name: "Mombasa Road",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "005",
    branch_name: "Chester",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "007",
    branch_name: "Waiyaki Way",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "008",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "009",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "010",
    branch_name: "Senator Cards",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "011",
    branch_name: "Nyali",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "012",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "013",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "015",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Spire Bank",
    bank_code: "49",
    branch_code: "016",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "001",
    branch_name: "Westlands",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "002",
    branch_name: "Parklands",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "003",
    branch_name: "Koinange Street",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "004",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "006",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "007",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "008",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Paramount Bank Limited",
    bank_code: "50",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "409",
    branch_name: "Kisii",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "502",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "503",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "507",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "603",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "001",
    branch_name: "Koinange Street",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "100",
    branch_name: "Kiongozi",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "101",
    branch_name: "Kayole",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "102",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "105",
    branch_name: "Kawangware",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "106",
    branch_name: "Kibera",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "107",
    branch_name: "Kariobangi",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "114",
    branch_name: "Funzi Road",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "115",
    branch_name: "Ngong Road",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "116",
    branch_name: "Kirinyaga Road",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "209",
    branch_name: "Machakos",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "210",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "213",
    branch_name: "Kiritiri",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "301",
    branch_name: "Thika",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "303",
    branch_name: "Muranga",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "305",
    branch_name: "Wangige",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "306",
    branch_name: "Kikuyu",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "307",
    branch_name: "Banana",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "308",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "310",
    branch_name: "Utawala",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "316",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "402",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "318",
    branch_name: "SACCO Clearing Centre",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "111",
    branch_name: "Central Clearing Center",
  },
  {
    bank_name: "Kingdom Bank Limited",
    bank_code: "51",
    branch_code: "401",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "001",
    branch_name: "Kimathi Street",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "002",
    branch_name: "Ind Area",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "003",
    branch_name: "Westlands",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "008",
    branch_name: "Muthaiga",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "009",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "010",
    branch_name: "Thika",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "011",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "012",
    branch_name: "Ngong Road",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "013",
    branch_name: "Meru",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "014",
    branch_name: "Nyali",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "015",
    branch_name: "Sky Park",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "016",
    branch_name: "Karen",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "004",
    branch_name: "Lavington",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "005",
    branch_name: "Nkrumah Road , Mombasa",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "006",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Guaranty Trust Bank ( Kenya) Ltd",
    bank_code: "53",
    branch_code: "007",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Victoria Commercial Bank",
    bank_code: "54",
    branch_code: "004",
    branch_name: "Ruaraka Branch",
  },
  {
    bank_name: "Victoria Commercial Bank",
    bank_code: "54",
    branch_code: "001",
    branch_name: "Victoria Towers, Upperhill",
  },
  {
    bank_name: "Victoria Commercial Bank",
    bank_code: "54",
    branch_code: "002",
    branch_name: "Riverside Drive",
  },
  {
    bank_name: "Victoria Commercial Bank",
    bank_code: "54",
    branch_code: "003",
    branch_name: "Lunga Lunga Square",
  },
  {
    bank_name: "Victoria Commercial Bank",
    bank_code: "54",
    branch_code: "005",
    branch_name: "Two Rivers",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "001",
    branch_name: "Head Office",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "002",
    branch_name: "Westlands",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "003",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "004",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "005",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "006",
    branch_name: "Moi Ave",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "007",
    branch_name: "Mombasa Road",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "008",
    branch_name: "Nyali",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "009",
    branch_name: "Ngong Road",
  },
  {
    bank_name: "Guardian Bank Limited",
    bank_code: "55",
    branch_code: "010",
    branch_name: "Nakuru",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "036",
    branch_name: "Spring Valley",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "037",
    branch_name: "Meru",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "000",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "001",
    branch_name: "2nd Ngong Avenue",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "002",
    branch_name: "Sarit Centre",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "003",
    branch_name: "Head Office",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "019",
    branch_name: "Riverside Drive Branch",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "020",
    branch_name: "Kisii",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "021",
    branch_name: "Changamwe",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "022",
    branch_name: "Malindi",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "023",
    branch_name: "Nyeri",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "024",
    branch_name: "Thika",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "025",
    branch_name: "Gigiri",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "026",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "027",
    branch_name: "Lavington Mall",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "028",
    branch_name: "Kitale",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "029",
    branch_name: "Lunga Lunga",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "030",
    branch_name: "Yaya Centre",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "031",
    branch_name: "Gateway Mall, Syokimau",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "032",
    branch_name: "Ruaraka",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "098",
    branch_name: "Card Center",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "004",
    branch_name: "Biashara St",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "005",
    branch_name: "Nyerere Avenue, Mombasa",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "006",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "007",
    branch_name: "Kisumu",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "008",
    branch_name: "Karen",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "009",
    branch_name: "Panari Centre",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "010",
    branch_name: "Parklands",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "011",
    branch_name: "Wilson Airport",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "012",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "013",
    branch_name: "South C Shopping Centre",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "014",
    branch_name: "Nyali Cinemax",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "015",
    branch_name: "Langata Link",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "016",
    branch_name: "Valley Arcade",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "017",
    branch_name: "Eldoret",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "018",
    branch_name: "NAKURU",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "034",
    branch_name: "Cross Road Off River Road",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "035",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "038",
    branch_name: "Eldama Park",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "039",
    branch_name: "Banda Street",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "040",
    branch_name: "Dunga Road",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "041",
    branch_name: "Ridge Court",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "042",
    branch_name: "Bandari Plaza",
  },
  {
    bank_name: "I&M BANK (KENYA) LTD",
    bank_code: "57",
    branch_code: "043",
    branch_name: "Mombasa, Moi Avenue",
  },
  {
    bank_name: "Development Bank of Kenya Limited",
    bank_code: "59",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Development Bank of Kenya Limited",
    bank_code: "59",
    branch_code: "001",
    branch_name: "Loita Street",
  },
  {
    bank_name: "Development Bank of Kenya Limited",
    bank_code: "59",
    branch_code: "002",
    branch_name: "Ngong Road Branch",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "078",
    branch_name: "Card Centre",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "100",
    branch_name: "Head Office - IPS Clearing Centre",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "079",
    branch_name: "Gikomba Xpress",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "081",
    branch_name: "Jubilee Arcade Branch",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "023",
    branch_name: "Buru Buru",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "024",
    branch_name: "Strathmore",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "025",
    branch_name: "Kisii",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "026",
    branch_name: "Virtual",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "027",
    branch_name: "Rafiki DTM Clearing Center",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "028",
    branch_name: "Chase Xpress - Ngong Road",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "029",
    branch_name: "Chase Elite ABC Place",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "030",
    branch_name: "Sameer Business Park",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "031",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "032",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "033",
    branch_name: "Westlands",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "034",
    branch_name: "Machakos",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "035",
    branch_name: "Mombasa Old Town",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "036",
    branch_name: "River Road",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "037",
    branch_name: "Lunga Lunga",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "038",
    branch_name: "Chase Xpress Dagoretti Corner",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "039",
    branch_name: "Chase Xpress Madaraka Corner",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "040",
    branch_name: "Kitale",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "041",
    branch_name: "Kimathi",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "042",
    branch_name: "Narok",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "043",
    branch_name: "SACCO Processing Centre",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "044",
    branch_name: "Garissa",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "045",
    branch_name: "KPA",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "046",
    branch_name: "Lavington",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "047",
    branch_name: "Kericho",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "048",
    branch_name: "Karen",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "049",
    branch_name: "Kilimani",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "050",
    branch_name: "Kasuku Centre",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "051",
    branch_name: "Kilifi",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "052",
    branch_name: "Kisumu Naivas",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "053",
    branch_name: "Ruaka",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "054",
    branch_name: "Garden City",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "055",
    branch_name: "Xpress Jomvu",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "056",
    branch_name: "Xpress Kitengela",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "057",
    branch_name: "Kayole",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "058",
    branch_name: "Xpress Limuru Road",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "059",
    branch_name: "Xpress Pangani",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "060",
    branch_name: "Xpress Nakuru",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "061",
    branch_name: "Xpress Eldoret",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "062",
    branch_name: "Ngong Milele",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "063",
    branch_name: "Corner House",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "064",
    branch_name: "Eastleigh III",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "022",
    branch_name: "Nyali",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "070",
    branch_name: "City Centre",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "065",
    branch_name: "Westlands",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "066",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "067",
    branch_name: "Diani",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "071",
    branch_name: "Malindi",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "068",
    branch_name: "Mombasa",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "076",
    branch_name: "Changamwe",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "069",
    branch_name: "Kilimani",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "075",
    branch_name: "New Muthaiga",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "072",
    branch_name: "Nyali",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "073",
    branch_name: "Sameer",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "074",
    branch_name: "Highridge",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "077",
    branch_name: "Garden City",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "016",
    branch_name: "Eldoret",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "001",
    branch_name: "City Centre Branch",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "003",
    branch_name: "Village Market",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "004",
    branch_name: "Mombasa Moi Avenue",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "005",
    branch_name: "Hurlingham",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "006",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "007",
    branch_name: "Parklands",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "008",
    branch_name: "Riverside Mews",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "010",
    branch_name: "Thika",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "011",
    branch_name: "Nakuru",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "012",
    branch_name: "Donholm",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "013",
    branch_name: "Bondeni",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "014",
    branch_name: "Ngara Mini",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "015",
    branch_name: "Kisumu",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "017",
    branch_name: "Diamond Plaza",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "018",
    branch_name: "Windsor",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "019",
    branch_name: "Malindi",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "020",
    branch_name: "Embakasi",
  },
  {
    bank_name: "State Bank of Mauritius Kenya",
    bank_code: "60",
    branch_code: "021",
    branch_name: "Upper Hill",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "024",
    branch_name: "Machakos",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "019",
    branch_name: "Hurlingham",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "020",
    branch_name: "Riveroad",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "250",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "022",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "025",
    branch_name: "Embu",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "016",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "017",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "018",
    branch_name: "Kisii",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "100",
    branch_name: "Head Office",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "200",
    branch_name: "Rehani House",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "210",
    branch_name: "Kenyatta Market",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "220",
    branch_name: "Gill House",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "230",
    branch_name: "Buru Buru",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "260",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "270",
    branch_name: "Sameer Business Park",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "280",
    branch_name: "Westlands",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "300",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "310",
    branch_name: "Nyali",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "400",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "410",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "500",
    branch_name: "Thika",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "510",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "520",
    branch_name: "Meru",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "600",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Housing Finance Bank",
    bank_code: "61",
    branch_code: "023",
    branch_name: "Komarock",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "066",
    branch_name: "Garissa",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "075",
    branch_name: "Gilgil",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "085",
    branch_name: "Homa Bay",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "095",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "096",
    branch_name: "Iten",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "100",
    branch_name: "Kabarnet",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "107",
    branch_name: "Kajiado",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "109",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "111",
    branch_name: "Kangundo",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "113",
    branch_name: "Kapenguria",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "115",
    branch_name: "Karuri",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "116",
    branch_name: "Kapsabet",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "119",
    branch_name: "Karatina",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "121",
    branch_name: "Karen",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "128",
    branch_name: "Kericho",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "308",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "309",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "312",
    branch_name: "Nandi Hills",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "314",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "315",
    branch_name: "Narok",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "327",
    branch_name: "Ngara Rd Nairobi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "329",
    branch_name: "Ngong",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "333",
    branch_name: "Nyahururu",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "341",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "001",
    branch_name: "Head Office",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "007",
    branch_name: "Athi River",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "013",
    branch_name: "Bomet",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "023",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "025",
    branch_name: "Busia",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "037",
    branch_name: "Chuka",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "047",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "050",
    branch_name: "Eldama Ravine",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "051",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "056",
    branch_name: "Embu",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "058",
    branch_name: "Enterprise Rd",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "249",
    branch_name: "Meru",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "272",
    branch_name: "Molo",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "273",
    branch_name: "Savani Hse Mombasa",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "291",
    branch_name: "Mumias",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "293",
    branch_name: "Muranga",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "298",
    branch_name: "Mwingi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "347",
    branch_name: "Nyamira",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "357",
    branch_name: "Oyugis",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "378",
    branch_name: "Ruiru",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "387",
    branch_name: "Sare Awendo",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "397",
    branch_name: "Siaya",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "409",
    branch_name: "Suna Migori",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "414",
    branch_name: "Taveta",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "416",
    branch_name: "Thika",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "428",
    branch_name: "Ukunda",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "436",
    branch_name: "Viwandani",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "437",
    branch_name: "Voi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "440",
    branch_name: "Mwea",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "442",
    branch_name: "Watamu",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "444",
    branch_name: "Webuye",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "448",
    branch_name: "Westlands Nairobi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "476",
    branch_name: "Emali",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "560",
    branch_name: "Chaani",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "592",
    branch_name: "Uthiru",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "605",
    branch_name: "Canon Hse Nairobi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "705",
    branch_name: "Afya Hse Nairobi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "707",
    branch_name: "Githurai",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "716",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "731",
    branch_name: "Moi Ave Mombasa",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "133",
    branch_name: "Keruguya",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "135",
    branch_name: "Keroka",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "139",
    branch_name: "Kahancha",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "141",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "142",
    branch_name: "Kibwezi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "151",
    branch_name: "Kikuyu",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "152",
    branch_name: "Kilifi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "159",
    branch_name: "Kisii",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "161",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "163",
    branch_name: "Kitale",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "164",
    branch_name: "Kitui",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "198",
    branch_name: "Likoni",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "199",
    branch_name: "Limuru",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "202",
    branch_name: "Lodwar",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "208",
    branch_name: "Luanda",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "213",
    branch_name: "Machakos",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "222",
    branch_name: "Matuu",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "223",
    branch_name: "Makueni",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "226",
    branch_name: "Malindi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "228",
    branch_name: "Mbale",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "232",
    branch_name: "Mariakani",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "236",
    branch_name: "Marsabit",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "239",
    branch_name: "Maua",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "746",
    branch_name: "NACICO Nairobi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "755",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "771",
    branch_name: "Kisauni Mombasa",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "782",
    branch_name: "Mlolongo",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "785",
    branch_name: "Adams Acade Nairobi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "786",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "787",
    branch_name: "Kariobangi",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "794",
    branch_name: "Mbita",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "795",
    branch_name: "Bodo",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "796",
    branch_name: "Maralal",
  },
  {
    bank_name: "Kenya Post Office Savings Bank",
    bank_code: "62",
    branch_code: "797",
    branch_name: "Kawangware",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "064",
    branch_name: "Watamu",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "065",
    branch_name: "Riverside",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "066",
    branch_name: "Rivaan Center",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "061",
    branch_name: "Narok",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "070",
    branch_name: "Mwanzi Road",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "069",
    branch_name: "Koinange Street",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "071",
    branch_name: "Enterprise Road",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "072",
    branch_name: "Nkuruma Road Mombasa",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "067",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "052",
    branch_name: "DTB Centre",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "053",
    branch_name: "South C",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "054",
    branch_name: "Lavington",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "056",
    branch_name: "Biashara street, Nakuru",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "059",
    branch_name: "Embu",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "060",
    branch_name: "Machakos",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "027",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "028",
    branch_name: "Kericho",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "029",
    branch_name: "Upper Hill",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "030",
    branch_name: "Wabera Street",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "031",
    branch_name: "Karen",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "032",
    branch_name: "Voi",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "033",
    branch_name: "Shimanzi",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "034",
    branch_name: "Meru",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "035",
    branch_name: "Diamond Plaza",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "036",
    branch_name: "crossroad",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "037",
    branch_name: "JKIA",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "038",
    branch_name: "Nyali",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "039",
    branch_name: "Migori Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "040",
    branch_name: "Madina Mall",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "001",
    branch_name: "Nation Centre",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "002",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "003",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "005",
    branch_name: "Parklands",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "006",
    branch_name: "Westgate",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "008",
    branch_name: "Mombasa Rd",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "009",
    branch_name: "Ind Area",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "010",
    branch_name: "Kisii",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "011",
    branch_name: "Malindi",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "012",
    branch_name: "Thika",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "013",
    branch_name: "Otc",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "041",
    branch_name: "Courtyard Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "042",
    branch_name: "Mtwapa Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "043",
    branch_name: "Lamu Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "044",
    branch_name: "Kilifi Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "045",
    branch_name: "Mariakani Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "046",
    branch_name: "Thika Road Mall",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "047",
    branch_name: "Ronald Ngala",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "048",
    branch_name: "Busia",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "049",
    branch_name: "West End Mall - Kisumu",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "050",
    branch_name: "Tom Mboya",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "077",
    branch_name: "Imaara Mall",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "074",
    branch_name: "Kahawa Sukari",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "076",
    branch_name: "Kamakis",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "080",
    branch_name: "Greenspan Mall Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "079",
    branch_name: "Likoni Mall Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "075",
    branch_name: "Sarit Centre",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "014",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "016",
    branch_name: "Changamwe",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "017",
    branch_name: "T-mall",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "018",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "019",
    branch_name: "Village Market",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "020",
    branch_name: "Diani",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "021",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "022",
    branch_name: "Kitale",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "023",
    branch_name: "Prestige",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "024",
    branch_name: "Buru Buru",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "025",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "026",
    branch_name: "Jomo Kenyatta Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "078",
    branch_name: "Kayole Junction",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "081",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "083",
    branch_name: "Kijabe Street",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "085",
    branch_name: "Kenol Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "087",
    branch_name: "Ol-Kalou Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "090",
    branch_name: "Githurai Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "082",
    branch_name: "New Eastleigh Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "084",
    branch_name: "Baba Dogo Branch",
  },
  {
    bank_name: "Diamond Trust Bank Limited",
    bank_code: "63",
    branch_code: "088",
    branch_name: "Ongata Rongai Branch",
  },
  {
    bank_name: "Mayfair CIB Bank",
    bank_code: "65",
    branch_code: "005",
    branch_name: "Industrial Area Branch",
  },
  {
    bank_name: "Mayfair CIB Bank",
    bank_code: "65",
    branch_code: "004",
    branch_name: "Eldoret Branch",
  },
  {
    bank_name: "Mayfair CIB Bank",
    bank_code: "65",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Mayfair CIB Bank",
    bank_code: "65",
    branch_code: "001",
    branch_name: "Westlands",
  },
  {
    bank_name: "Mayfair CIB Bank",
    bank_code: "65",
    branch_code: "002",
    branch_name: "Mayfair Centre",
  },
  {
    bank_name: "Mayfair CIB Bank",
    bank_code: "65",
    branch_code: "003",
    branch_name: "Nyali",
  },
  {
    bank_name: "Mayfair CIB Bank",
    bank_code: "65",
    branch_code: "006",
    branch_name: "Upperhill",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "051",
    branch_name: "Sameer Park",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "052",
    branch_name: "River Road",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "053",
    branch_name: "Two Rivers",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "054",
    branch_name: "The Mall Westlands",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "001",
    branch_name: "Main Office",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "002",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "003",
    branch_name: "Kenyatta Ave Nbi",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "004",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "005",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "006",
    branch_name: "Buruburu",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "007",
    branch_name: "Embu",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "008",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "009",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "010",
    branch_name: "Kericho",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "011",
    branch_name: "Mlolongo",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "012",
    branch_name: "Thika",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "013",
    branch_name: "Kerugoya",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "014",
    branch_name: "Kenyatta Market",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "015",
    branch_name: "Kisii",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "016",
    branch_name: "CHUKA",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "017",
    branch_name: "Kitui",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "018",
    branch_name: "Machakos",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "019",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "020",
    branch_name: "Kangemi",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "021",
    branch_name: "Email",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "022",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "023",
    branch_name: "Nyahururu",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "024",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "025",
    branch_name: "Meru",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "026",
    branch_name: "Kitale",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "027",
    branch_name: "Kibwezi",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "028",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "029",
    branch_name: "Kajiado",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "030",
    branch_name: "Nkubu",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "031",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "032",
    branch_name: "Busia",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "033",
    branch_name: "Moi Nbi",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "034",
    branch_name: "Mwea",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "035",
    branch_name: "Kengeleni",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "036",
    branch_name: "Kilimani",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "037",
    branch_name: "Rongai",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "100",
    branch_name: "Head Office",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "058",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Sidian Bank Limited",
    bank_code: "66",
    branch_code: "059",
    branch_name: "Kamakis",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "175",
    branch_name: "Garden City",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "178",
    branch_name: "Wangige Sub Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "176",
    branch_name: "Mlolongo",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "177",
    branch_name: "Embassy House",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "180",
    branch_name: "Kawangware sub Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "179",
    branch_name: "Utawala",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "190",
    branch_name: "Engineer",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "191",
    branch_name: "Njabini",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "011",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "012",
    branch_name: "Tom Mboya",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "013",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "014",
    branch_name: "Meru",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "015",
    branch_name: "Mama Ngina",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "016",
    branch_name: "Nyahururu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "017",
    branch_name: "Community",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "018",
    branch_name: "Community Corporate",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "019",
    branch_name: "Embu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "020",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "021",
    branch_name: "Chuka",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "084",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "085",
    branch_name: "Namanga",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "086",
    branch_name: "Kajiado",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "087",
    branch_name: "Ruiru",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "088",
    branch_name: "Otc",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "089",
    branch_name: "Kenol",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "090",
    branch_name: "Tala",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "091",
    branch_name: "Ngara",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "092",
    branch_name: "Nandi Hills",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "093",
    branch_name: "Githunguri",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "094",
    branch_name: "Tea Room",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "095",
    branch_name: "Buru Buru",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "096",
    branch_name: "Mbale",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "097",
    branch_name: "Siaya",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "098",
    branch_name: "Homa Bay",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "022",
    branch_name: "Muranga",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "023",
    branch_name: "Molo",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "024",
    branch_name: "Harambee Avenu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "025",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "026",
    branch_name: "Kimathi Street",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "027",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "028",
    branch_name: "Kericho",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "029",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "030",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "031",
    branch_name: "Nakuru Kenyatta Avenue",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "032",
    branch_name: "Kariobangi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "033",
    branch_name: "Kitale",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "034",
    branch_name: "Thika Kenyatta Avenue",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "035",
    branch_name: "Knut House",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "036",
    branch_name: "Narok",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "037",
    branch_name: "Nkubu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "038",
    branch_name: "Mwea",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "039",
    branch_name: "Matuu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "040",
    branch_name: "Maua",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "041",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "042",
    branch_name: "Kagio",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "043",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "044",
    branch_name: "Ukunda",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "045",
    branch_name: "Malindi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "046",
    branch_name: "Mombasa Digo Road",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "047",
    branch_name: "Moi Avenue",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "048",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "049",
    branch_name: "Kapsabet",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "050",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "051",
    branch_name: "Kisii",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "052",
    branch_name: "Nyamira",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "053",
    branch_name: "Litein",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "054",
    branch_name: "Equity Centre Diaspora",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "055",
    branch_name: "Westlands",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "056",
    branch_name: "Industrial Area Kenpipe Plaza",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "057",
    branch_name: "Kikuyu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "058",
    branch_name: "Garissa",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "059",
    branch_name: "Mwingi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "060",
    branch_name: "Machakos",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "061",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "062",
    branch_name: "Ol-kalao",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "063",
    branch_name: "Kawangware",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "064",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "065",
    branch_name: "Kayole",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "066",
    branch_name: "Gatundu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "067",
    branch_name: "Wote",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "068",
    branch_name: "Mumias",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "069",
    branch_name: "Limuru",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "070",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "071",
    branch_name: "Githurai",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "072",
    branch_name: "Kitui",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "073",
    branch_name: "Ngong",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "074",
    branch_name: "Loitoktok",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "075",
    branch_name: "Bondo",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "076",
    branch_name: "Mbita",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "077",
    branch_name: "Gilgil",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "078",
    branch_name: "Busia",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "079",
    branch_name: "Voi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "080",
    branch_name: "Enterprise Road",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "081",
    branch_name: "Equity Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "082",
    branch_name: "Donholm",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "083",
    branch_name: "Mukurwe-ini",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "006",
    branch_name: "Murarandia",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "007",
    branch_name: "Kangari",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "008",
    branch_name: "Othaya",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "009",
    branch_name: "Thika / Equity Plaza",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "010",
    branch_name: "Kerugoya",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "116",
    branch_name: "Migori",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "117",
    branch_name: "Kibera",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "118",
    branch_name: "Kasarani",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "119",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "120",
    branch_name: "Changamwe",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "121",
    branch_name: "Hola",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "122",
    branch_name: "Bomet",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "123",
    branch_name: "Kilgoris",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "124",
    branch_name: "Keroka",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "125",
    branch_name: "KAREN",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "126",
    branch_name: "KISUMU ANGAWA AVE",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "127",
    branch_name: "MPEKETONI",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "128",
    branch_name: "NAIROBI WEST",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "129",
    branch_name: "KENYATTA AVENUE",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "130",
    branch_name: "City Hall",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "131",
    branch_name: "Eldama Ravine",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "132",
    branch_name: "Embakasi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "133",
    branch_name: "KPCU",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "134",
    branch_name: "Ridgeways",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "135",
    branch_name: "Runyenjes Sub Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "136",
    branch_name: "Dadaad",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "137",
    branch_name: "Kangemi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "138",
    branch_name: "Nyali Centre Corporate",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "139",
    branch_name: "Kabarnet",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "140",
    branch_name: "Westlands Corporate",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "141",
    branch_name: "Lavington Corporate",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "142",
    branch_name: "Taita Taveta",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "143",
    branch_name: "Awendo",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "144",
    branch_name: "Ruai",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "145",
    branch_name: "Kilimani",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "146",
    branch_name: "Nakuru Westside Mall",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "147",
    branch_name: "Kilimani Supreme",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "148",
    branch_name: "JKIA Cargo Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "149",
    branch_name: "EPZ Athi River",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "150",
    branch_name: "Oyugis",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "151",
    branch_name: "Mayfair Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "152",
    branch_name: "Juja",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "153",
    branch_name: "Iten",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "154",
    branch_name: "Nyali Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "155",
    branch_name: "Thika Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "156",
    branch_name: "Mombasa Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "157",
    branch_name: "Kapsowar Sub-Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "158",
    branch_name: "Kwale",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "159",
    branch_name: "Lamu",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "000",
    branch_name: "Equity Bank Head Office",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "001",
    branch_name: "Equity Bank Corporate",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "002",
    branch_name: "Equity Bank Fourways",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "003",
    branch_name: "Kangema",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "004",
    branch_name: "Karatina",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "005",
    branch_name: "Kiriaini",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "174",
    branch_name: "Ruaka",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "777",
    branch_name: "Equity Hapo Hapo",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "099",
    branch_name: "Lodwar",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "100",
    branch_name: "Mandera",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "101",
    branch_name: "Marsabit",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "102",
    branch_name: "Moyale",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "103",
    branch_name: "Wajir",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "104",
    branch_name: "Meru Makutano",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "105",
    branch_name: "Malaba Town",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "106",
    branch_name: "Kilifi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "107",
    branch_name: "Kapenguria",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "108",
    branch_name: "Mombasa Road",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "109",
    branch_name: "Eldoret Market",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "110",
    branch_name: "Maralal",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "111",
    branch_name: "Kimende",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "112",
    branch_name: "Luanda",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "113",
    branch_name: "Ku Sub Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "114",
    branch_name: "Kengeleni",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "115",
    branch_name: "Nyeri Kimathi Way",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "160",
    branch_name: "Kenyatta Avenue Supreme",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "161",
    branch_name: "KPA Sub-Branch Mombasa",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "162",
    branch_name: "Gigiri Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "163",
    branch_name: "Karen Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "164",
    branch_name: "Eldoret Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "165",
    branch_name: "Kakuma",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "166",
    branch_name: "Archers Post",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "167",
    branch_name: "Mutomo",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "168",
    branch_name: "Kiserian Sub Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "169",
    branch_name: "Dagoretti Corner",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "170",
    branch_name: "Kisumu Supreme Centre",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "171",
    branch_name: "Thika Makongeni",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "172",
    branch_name: "Kutus Sub - Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "173",
    branch_name: "Kibwezi Sub - Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "192",
    branch_name: "Kahawa West",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "194",
    branch_name: "Chaka",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "185",
    branch_name: "Isinya",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "187",
    branch_name: "Isibania",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "188",
    branch_name: "Kenyatta Market",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "189",
    branch_name: "Inland Container Depot (ICD) Embakasi",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "182",
    branch_name: "Kagwe Sub - Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "181",
    branch_name: "Emali Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "183",
    branch_name: "Rumuruti Branch",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "184",
    branch_name: "Sotik",
  },
  {
    bank_name: "Equity Bank Limited",
    bank_code: "68",
    branch_code: "186",
    branch_name: "Laare",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "030",
    branch_name: "Kangemi",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "010",
    branch_name: "JKIA",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "020",
    branch_name: "Kutus",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "070",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "001",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "002",
    branch_name: "Githunguri",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "003",
    branch_name: "Sonalux",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "004",
    branch_name: "Gatundu",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "005",
    branch_name: "Thika",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "006",
    branch_name: "Muranga",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "007",
    branch_name: "Kangari",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "008",
    branch_name: "Kiria-ini",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "009",
    branch_name: "Kangema",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "011",
    branch_name: "Othaya",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "012",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "014",
    branch_name: "Cargen House",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "015",
    branch_name: "Laptrust",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "016",
    branch_name: "City Hall Annex",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "017",
    branch_name: "Kasarani",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "018",
    branch_name: "Nakuru Finance House",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "019",
    branch_name: "Nakuru Market",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "021",
    branch_name: "Dagoretti",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "022",
    branch_name: "Kericho",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "023",
    branch_name: "Nyahururu",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "024",
    branch_name: "Ruiru",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "025",
    branch_name: "Kisumu Reliance",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "026",
    branch_name: "Nyamira",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "027",
    branch_name: "Kisii",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "028",
    branch_name: "Kisumu Al Imran",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "029",
    branch_name: "Narok",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "031",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "032",
    branch_name: "Thika Makongeni",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "033",
    branch_name: "Donholm",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "034",
    branch_name: "Utawala",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "035",
    branch_name: "Fourways Retail Branch",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "036",
    branch_name: "Mlolongo",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "037",
    branch_name: "Olkalou",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "038",
    branch_name: "Ktda Plaza",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "039",
    branch_name: "Gateway Mall Nairobi",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "041",
    branch_name: "Kariobangi",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "042",
    branch_name: "Gikomba Area 42",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "043",
    branch_name: "Sokoni",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "044",
    branch_name: "Kahawa West",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "045",
    branch_name: "Githurai",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "046",
    branch_name: "Yaya",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "047",
    branch_name: "Limuru",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "066",
    branch_name: "Ongata Rongai",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "067",
    branch_name: "Kajiado",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "068",
    branch_name: "Fourways Corporate Branch",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "069",
    branch_name: "Ngara",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "071",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "072",
    branch_name: "Kitui",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "073",
    branch_name: "Mackakos",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "074",
    branch_name: "Migori",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "075",
    branch_name: "Embu",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "076",
    branch_name: "Mwea",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "077",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "078",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "079",
    branch_name: "Busia",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "081",
    branch_name: "Mumias",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "082",
    branch_name: "Eldoret West",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "083",
    branch_name: "Molo",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "084",
    branch_name: "Bomet",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "085",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "086",
    branch_name: "Maua",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "087",
    branch_name: "Litein",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "088",
    branch_name: "Wote",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "089",
    branch_name: "Bamburi",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "091",
    branch_name: "Ukunda",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "092",
    branch_name: "Digo",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "093",
    branch_name: "Kitale",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "094",
    branch_name: "Mtwapa",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "095",
    branch_name: "Mombasa Nkrumah Road",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "096",
    branch_name: "Mombasa Jomo Kenyatta Avenue",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "097",
    branch_name: "Kapsabet",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "098",
    branch_name: "Malindi",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "102",
    branch_name: "Kikuyu",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "048",
    branch_name: "Westlands",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "049",
    branch_name: "Kagwe",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "051",
    branch_name: "Banana",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "052",
    branch_name: "Ruaka",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "053",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "054",
    branch_name: "Chuka",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "055",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "056",
    branch_name: "Karatina",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "057",
    branch_name: "Kerugoya",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "058",
    branch_name: "Tom Mboya",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "059",
    branch_name: "River Road",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "061",
    branch_name: "Kayole",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "062",
    branch_name: "Nkubu",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "063",
    branch_name: "Meru",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "064",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "065",
    branch_name: "Ktda Plaza Corporate",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "703",
    branch_name: "Stima Sacco Branch",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "099",
    branch_name: "Eastleigh Branch",
  },
  {
    bank_name: "Family Bank Ltd",
    bank_code: "70",
    branch_code: "101",
    branch_name: "Wangige -Kiambu",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "019",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "020",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "001",
    branch_name: "Central Clearing Centre",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "002",
    branch_name: "Upperhill",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "003",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "004",
    branch_name: "Kenyatta Avenue",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "005",
    branch_name: "Mombasa",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "006",
    branch_name: "Garissa",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "007",
    branch_name: "Lamu",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "008",
    branch_name: "Malindi",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "009",
    branch_name: "Muthaiga",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "010",
    branch_name: "Bondeni",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "011",
    branch_name: "Eastleigh 7th Street",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "012",
    branch_name: "Eastleigh Athumani Kipanga Street",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "014",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "015",
    branch_name: "Jomo Kenyatta Avenue",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "017",
    branch_name: "Mombasa Road",
  },
  {
    bank_name: "Gulf African Bank Ltd",
    bank_code: "72",
    branch_code: "018",
    branch_name: "Annisaa Bondeni",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "001",
    branch_name: "Wabera Street",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "002",
    branch_name: "Eastleigh 1",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "003",
    branch_name: "Mombasa 1",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "004",
    branch_name: "Garissa",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "005",
    branch_name: "Eastleigh 2 - General Waruinge",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "006",
    branch_name: "Malindi",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "007",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "008",
    branch_name: "Kimathi Street",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "009",
    branch_name: "Westlands",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "010",
    branch_name: "South C",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "011",
    branch_name: "Industrial Area",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "012",
    branch_name: "Masalani",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "013",
    branch_name: "Habasweni",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "014",
    branch_name: "Wajir",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "015",
    branch_name: "Moyale",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "016",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "017",
    branch_name: "Imaara Building",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "018",
    branch_name: "Lunga Lunga",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "019",
    branch_name: "Isiolo",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "020",
    branch_name: "Mihrab",
  },
  {
    bank_name: "Premier Bank Kenya Limited",
    bank_code: "74",
    branch_code: "999",
    branch_name: "Head Office/clearing Center",
  },
  {
    bank_name: "DIB Bank Kenya Limited",
    bank_code: "75",
    branch_code: "004",
    branch_name: "Eastleigh",
  },
  {
    bank_name: "DIB Bank Kenya Limited",
    bank_code: "75",
    branch_code: "005",
    branch_name: "Bondeni",
  },
  {
    bank_name: "DIB Bank Kenya Limited",
    bank_code: "75",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "DIB Bank Kenya Limited",
    bank_code: "75",
    branch_code: "006",
    branch_name: "Banda Street",
  },
  {
    bank_name: "DIB Bank Kenya Limited",
    bank_code: "75",
    branch_code: "003",
    branch_name: "Moi Avenue Mombasa",
  },
  {
    bank_name: "DIB Bank Kenya Limited",
    bank_code: "75",
    branch_code: "001",
    branch_name: "Upper Hill Branch",
  },
  {
    bank_name: "DIB Bank Kenya Limited",
    bank_code: "75",
    branch_code: "002",
    branch_name: "Sarit Branch",
  },
  {
    bank_name: "UBA Kenya Bank Ltd",
    bank_code: "76",
    branch_code: "005",
    branch_name: "Nakuru",
  },
  {
    bank_name: "UBA Kenya Bank Ltd",
    bank_code: "76",
    branch_code: "004",
    branch_name: "Mombasa",
  },
  {
    bank_name: "UBA Kenya Bank Ltd",
    bank_code: "76",
    branch_code: "003",
    branch_name: "Upper Hill",
  },
  {
    bank_name: "UBA Kenya Bank Ltd",
    bank_code: "76",
    branch_code: "099",
    branch_name: "Head Office",
  },
  {
    bank_name: "UBA Kenya Bank Ltd",
    bank_code: "76",
    branch_code: "001",
    branch_name: "Westlands",
  },
  {
    bank_name: "UBA Kenya Bank Ltd",
    bank_code: "76",
    branch_code: "002",
    branch_name: "Enterprise Road",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "001",
    branch_name: "Kakamega Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "002",
    branch_name: "Eldoret Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "003",
    branch_name: "Nyeri Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "004",
    branch_name: "Mombasa Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "005",
    branch_name: "River Rd Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "006",
    branch_name: "Malindi Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "007",
    branch_name: "Kericho Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "008",
    branch_name: "Machakos Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "009",
    branch_name: "Embu Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "010",
    branch_name: "Kisii Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "011",
    branch_name: "Nanyuki Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "012",
    branch_name: "Migori Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "013",
    branch_name: "Thika Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "014",
    branch_name: "Kitale Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "000",
    branch_name: "Head Office",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "023",
    branch_name: "Kitui",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "015",
    branch_name: "Nakuru Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "016",
    branch_name: "Emali Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "017",
    branch_name: "Voi Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "018",
    branch_name: "Kisumu Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "019",
    branch_name: "Meru Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "020",
    branch_name: "Diani Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "021",
    branch_name: "Upperhill Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "022",
    branch_name: "Naivasha Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "024",
    branch_name: "Busia Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "027",
    branch_name: "Kariobangi Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "028",
    branch_name: "Bungoma Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "029",
    branch_name: "Bomet Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "031",
    branch_name: "Kawangware Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "032",
    branch_name: "Gikomba Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "033",
    branch_name: "Kiambu Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "034",
    branch_name: "Rongai Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "041",
    branch_name: "Marsabit Branch",
  },
  {
    bank_name: "Kenya Women Microfinance Bank",
    bank_code: "78",
    branch_code: "043",
    branch_name: "Lodwar Branch",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "003",
    branch_name: "Kariobangi",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "004",
    branch_name: "Githurai",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "046",
    branch_name: "Kawangware",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "047",
    branch_name: "Kayole",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "048",
    branch_name: "Matuu",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "049",
    branch_name: "Mwea",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "050",
    branch_name: "Makutano",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "051",
    branch_name: "Mumias",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "052",
    branch_name: "Kiserian",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "053",
    branch_name: "Rongai",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "055",
    branch_name: "Migori",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "062",
    branch_name: "Kilifi",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "080",
    branch_name: "Kibera",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "084",
    branch_name: "Moi Avenue MSA",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "079",
    branch_name: "Kimathi St",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "005",
    branch_name: "Machakos",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "006",
    branch_name: "Ngong Road",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "002",
    branch_name: "OTC",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "007",
    branch_name: "Kiambu",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "008",
    branch_name: "Nakuru",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "009",
    branch_name: "Nyahururu",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "010",
    branch_name: "Molo",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "013",
    branch_name: "Naivasha",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "015",
    branch_name: "Eldoret",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "016",
    branch_name: "Bungoma",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "017",
    branch_name: "Kitale",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "018",
    branch_name: "Mois Bridge",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "019",
    branch_name: "Kisumu",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "020",
    branch_name: "Nyeri",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "021",
    branch_name: "Thika",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "022",
    branch_name: "Meru",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "025",
    branch_name: "Malindi",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "027",
    branch_name: "Kitengela",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "023",
    branch_name: "Embu",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "024",
    branch_name: "Mombasa Central",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "029",
    branch_name: "Narok",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "031",
    branch_name: "Kabarnet",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "032",
    branch_name: "Karatina",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "035",
    branch_name: "Muranga",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "036",
    branch_name: "Nanyuki",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "039",
    branch_name: "Maua",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "042",
    branch_name: "Litein",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "043",
    branch_name: "Kengeleni",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "083",
    branch_name: "Jevanjee",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "034",
    branch_name: "Kitui",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "033",
    branch_name: "Mwingi",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "041",
    branch_name: "Kakamega",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "011",
    branch_name: "Bomet",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "044",
    branch_name: "Changamwe",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "058",
    branch_name: "Ukunda",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "054",
    branch_name: "Bondo",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "086",
    branch_name: "Gikomba",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "056",
    branch_name: "Ugunja",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "065",
    branch_name: "Kapenguria",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "045",
    branch_name: "Voi",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "085",
    branch_name: "Homabay",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "074",
    branch_name: "Busia",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "060",
    branch_name: "Limuru",
  },
  {
    bank_name: "Faulu Microfinance Bank Ltd",
    bank_code: "79",
    branch_code: "012",
    branch_name: "Kericho",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "001",
    branch_name: "Head Office",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "002",
    branch_name: "Cardinal Otunga Plaza",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "003",
    branch_name: "Cardinal Otunga Annex",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "004",
    branch_name: "Kawangware",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "005",
    branch_name: "Donholm",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "006",
    branch_name: "Thika",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "007",
    branch_name: "Karuri",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "008",
    branch_name: "Karen",
  },
  {
    bank_name: "Caritas Microfinance Bank Ltd",
    bank_code: "80",
    branch_code: "009",
    branch_name: "Nyeri",
  },
  {
    bank_name: "NCBA Bank Kenya Plc",
    bank_code: "07",
    branch_code: "033",
    branch_name: "River Road",
  },
];
